/* ==========================================================================
   Starter Stak Deluxe — paid-social landing page 10A, binding layer.

   The page turns on ONE value: the shopper's matched Cream Concealer code.

     matched  written only by the shade-match team, via Kustomer chat. The
              existing assets/violet-shade-match.js applies the worker's
              answer to the hidden compatibility selects this section renders
              and dispatches `change`; that change is the only thing here
              that may set `matched`. Persisted to localStorage so a reload
              or a bounce back from checkout keeps it, and carried into the
              cart line as a hidden `_shade_match` property.

     pick     a swatch or a face the shopper tapped. A pick fills the matcher
              panel and drives the matcher's own buy button, and never flips
              the chat-handoff CTAs (header, hero, band CTAs). Tapping a face
              is not the same as being matched — that distinction is the
              whole point of the page.

   Everything else is derived: the BB Powder pan photo, the concealer tint,
   the Powder Bronzer name, the variant that goes in the bag.
   ========================================================================== */

(function () {
  'use strict';

  var STORAGE_KEY = 'subtl:ssd10:match';

  function boot() {
    if (document.documentElement.__ssd10Bound) return;
    if (!document.querySelector('[data-ssd10-state]')) return;
    document.documentElement.__ssd10Bound = true;

    // ── Data ────────────────────────────────────────────────────────────────
    // The page is six sections sharing one shade, so everything is queried at
    // document level. ssd-10a-chrome emits the state; the strings are merged
    // across sections because each owns the copy it renders.

    function readJSON(sel, fallback) {
      var el = document.querySelector(sel);
      if (!el) return fallback;
      try { return JSON.parse(el.textContent); } catch (e) { return fallback; }
    }

    function readPairs(sel) {
      var el = document.querySelector(sel);
      var out = {};
      if (!el) return out;
      el.textContent.trim().split('|').forEach(function (pair) {
        var bits = pair.split(':');
        if (bits.length >= 2 && bits[0]) out[bits[0].trim()] = bits.slice(1).join(':').trim();
      });
      return out;
    }

    var variants = readJSON('[data-ssd10-variants]', []);
    var pans = readJSON('[data-ssd10-pans]', {});
    var worn = readJSON('[data-ssd10-worn]', {});
    var bronzerMap = readPairs('[data-ssd10-bronzer-map]');
    var bbMap = readPairs('[data-ssd10-bb-map]');
    var ssdMedia = readJSON('[data-ssd10-ssd-media]', { media: [], featured: {} });

    // Undertone letter -> { lipcheek, eyeshadow }. Rows are "letter:lipcheek:eyeshadow".
    var undertoneMap = {};
    (function () {
      var el = document.querySelector('[data-ssd10-undertone-map]');
      if (!el) return;
      el.textContent.trim().split('|').forEach(function (row) {
        var f = row.split(':');
        if (f.length >= 3) undertoneMap[f[0].trim().toUpperCase()] = { lipcheek: f[1].trim(), eyeshadow: f[2].trim() };
      });
    })();

    var strings = {};
    Array.prototype.forEach.call(document.querySelectorAll('[data-ssd10-strings]'), function (el) {
      try {
        var part = JSON.parse(el.textContent);
        Object.keys(part).forEach(function (k) { strings[k] = part[k]; });
      } catch (e) { /* a malformed blob should not take the page down */ }
    });

    // shade table rows are "code:hex:tone:tier:fg:plate"
    var shades = {};
    var tableEl = document.querySelector('[data-ssd10-shade-table]');
    if (tableEl) {
      tableEl.textContent.trim().split('|').forEach(function (row) {
        var f = row.split(':');
        if (f.length >= 4) shades[f[0]] = { hex: f[1], tone: f[2], tier: f[3] };
      });
    }

    var TONE_WORD = { cool: 'cool undertones', neutral: 'neutral undertones', warm: 'warm undertones' };

    function fill(tpl, map) {
      return String(tpl || '').replace(/\{(\w+)\}/g, function (whole, key) {
        return Object.prototype.hasOwnProperty.call(map, key) ? map[key] : whole;
      });
    }

    // ── State ───────────────────────────────────────────────────────────────

    var state = { matched: null, matchedBB: null, pick: null, pickFace: null, tone: 'all', matchedBy: null, matchId: null };

    try {
      var saved = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || 'null');
      if (saved && saved.shade && shades[saved.shade]) {
        state.matched = saved.shade;
        state.matchedBB = saved.bb || null;
        state.pick = saved.shade;
      }
    } catch (e) { /* private mode, or nothing stored — pre-match is the right default */ }

    // A matched shopper lands on their own tone tab, not "All 19".
    function toneOf(code) {
      var sh = code && shades[code];
      return sh && sh.tone && document.querySelector('[data-ssd10-chip="' + sh.tone + '"]') ? sh.tone : null;
    }
    if (state.matched && toneOf(state.matched)) state.tone = toneOf(state.matched);

    function persist() {
      try {
        if (state.matched) {
          window.localStorage.setItem(STORAGE_KEY, JSON.stringify({ shade: state.matched, bb: state.matchedBB }));
        } else {
          window.localStorage.removeItem(STORAGE_KEY);
        }
      } catch (e) { /* nothing we can do, and nothing that should break the page */ }
    }

    // ── Derived values ──────────────────────────────────────────────────────

    function bbFor(code) {
      // A real BB Powder recommendation from the worker always wins over the
      // store pairing in snippets/bb-powder-shade-map.liquid — three concealers
      // pair with two pans and the map has to pick one, the worker does not.
      if (state.matchedBB && state.matched === code) return state.matchedBB;
      return bbMap[code] || null;
    }

    // Mirrors snippets/undertone-resolve.liquid, which owns this rule: the
    // code's trailing letter picks the pairing, anything unrecognised falls
    // safe to neutral. Parsed rather than listed so a new code inherits it.
    function undertoneFor(code) {
      var letter = String(code || '').trim().toUpperCase().slice(-1);
      return undertoneMap[letter] || undertoneMap.N || { lipcheek: '', eyeshadow: '' };
    }

    // Every pod's shade for a given concealer, in one place.
    function pairingFor(code) {
      var u = undertoneFor(code);
      return { concealer: code, bb: bbFor(code), bronzer: bronzerMap[code] || '',
               lipcheek: u.lipcheek, eyeshadow: u.eyeshadow };
    }

    function variantFor(code) {
      if (!code) return null;
      var bb = bbFor(code);
      var exact = null;
      var sameConcealer = null;
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        if (v.o2 !== code) continue;
        if (!sameConcealer || (!sameConcealer.a && v.a)) sameConcealer = v;
        if (bb && v.o1 === bb) { exact = v; if (v.a) break; }
      }
      return exact || sameConcealer;
    }

    function priceLabel(code) {
      return fill(strings.bagLabel, { shade: code, price: strings.price || '' });
    }

    // ── DOM helpers ─────────────────────────────────────────────────────────

    function each(sel, fn) {
      Array.prototype.forEach.call(document.querySelectorAll(sel), fn);
    }

    // Each section renders its own empty-state copy from its own settings, so
    // the first render captures that text rather than the strings blob
    // carrying a second copy of it. Only templated strings live in the blobs.
    function emptyOf(el) {
      if (typeof el.dataset.ssd10Empty !== 'string') el.dataset.ssd10Empty = el.textContent.trim();
      return el.dataset.ssd10Empty;
    }

    function setSwatchBox(el, code) {
      if (!code) {
        el.style.background = 'transparent';
        el.style.border = '';
        el.classList.remove('is-filled');
        return;
      }
      var sh = shades[code];
      el.style.background = sh ? sh.hex : 'transparent';
      el.style.border = '1px solid rgba(87,32,31,0.3)';
      el.classList.add('is-filled');
    }

    // ── Render ──────────────────────────────────────────────────────────────

    function render() {
      var matched = state.matched;
      var pick = state.pick;
      // The shade IN PLAY drives every image, badge and bag label on the
      // page: the shopper's pick when there is one, otherwise the match. The
      // MATCHED flag and the chat-handoff CTAs still follow the match alone.
      var inPlay = pick || matched;

      // Chat-handoff CTAs: pre-match copy vs "Add to bag in {code}".
      each('[data-ssd10-pre]', function (el) { el.hidden = !!matched; });
      each('[data-ssd10-bag]', function (el) { el.hidden = !matched; });
      // Violet's coin on the result swatch only while her match is the shade
      // in play; a hand pick of another shade takes it off.
      each('[data-ssd10-result-badge]', function (el) { el.hidden = !(matched && inPlay === matched); });
      each('[data-ssd10-bag-label]', function (el) { el.textContent = matched ? priceLabel(inPlay) : ''; });
      each('[data-ssd10-mine-line]', function (el) {
        el.textContent = matched ? fill(strings.mineLine, { shade: matched }) : '';
      });
      each('[data-ssd10-bag-badge]', function (el) {
        el.textContent = matched ? fill(strings.bagBadge, { shade: inPlay }) : '';
      });

      // Each shade-driven pod's badge names the shade it actually resolves to,
      // so the label agrees with the pan pictured beside it.
      each('[data-ssd10-role-badge]', function (el) {
        var role = el.dataset.ssd10RoleBadge;
        if (!inPlay) { el.textContent = ''; return; }
        var shade = pairingFor(inPlay)[role] || null;
        if (!shade) { el.textContent = ''; return; }
        // The BB Powder and Bronzer are never chosen — both follow the
        // concealer — so their badge leads with MATCHED rather than naming a
        // shade the shopper never picked.
        el.textContent = role === 'concealer'
          ? fill(strings.bagBadge, { shade: shade })
          : fill(strings.roleBadge || 'MATCHED · {shade}', { shade: String(shade).toUpperCase() });
      });

      // Once matched, a CTA buys instead of opening chat, so it must stop
      // being a chat trigger — layout/landing.liquid listens for [data-open-chat].
      each('[data-ssd10-cta]', function (el) {
        if (matched) {
          el.removeAttribute('data-open-chat');
          el.setAttribute('href', '#ssd10-shade');
        } else {
          el.setAttribute('data-open-chat', '');
          el.setAttribute('href', '#openchat');
        }
      });

      // Pod art follows the shade in play — a pick as much as a match — so
      // the shopper sees the Stak they are looking at. Each pod's pans come
      // from its own product.
      each('[data-ssd10-pan]', function (el) {
        if (!el.dataset.defaultSrc) el.dataset.defaultSrc = el.getAttribute('src') || '';
        var role = el.dataset.ssd10Pan;
        var shade = null;
        if (inPlay) shade = pairingFor(inPlay)[role] || null;
        // The stack column asks for the pan on its own, the kit grid for the
        // variant shot. A missing pan falls back to the variant image so the
        // uploads can land a few at a time.
        var want = el.dataset.ssd10PanSource === 'pan' ? 'pan' : 'variant';
        var byRole = (pans[want] || {})[role] || {};
        var next = (shade && byRole[shade])
          || (shade && want === 'pan' && ((pans.variant || {})[role] || {})[shade])
          || el.dataset.defaultSrc;
        if (next && el.getAttribute('src') !== next) el.setAttribute('src', next);
        // The alt names the shade shown: "[Product] in [shade]".
        if (el.dataset.ssd10AltBase) el.alt = shade ? el.dataset.ssd10AltBase + ' in ' + shade : el.dataset.ssd10AltBase;
      });
      // The concealer pan is now the real photo of the matched shade, so the
      // handoff's colour-multiply stand-in is no longer needed. Kept hidden
      // rather than removed in case a pod ever lacks per-shade photography.
      each('[data-ssd10-pan-tint]', function (el) { el.hidden = true; });

      // Bridge band carries the pick down into the matcher.
      var bridgeSwatch = document.querySelector('[data-ssd10-bridge-swatch]');
      var bridgeEyebrow = document.querySelector('[data-ssd10-bridge-eyebrow]');
      var bridgeLine = document.querySelector('[data-ssd10-bridge-line]');
      if (bridgeSwatch) {
        if (pick && shades[pick]) {
          bridgeSwatch.style.background = shades[pick].hex;
          bridgeSwatch.style.border = '1px solid rgba(231,224,244,0.55)';
        } else {
          bridgeSwatch.style.background = 'transparent';
          bridgeSwatch.style.border = '1px dashed rgba(231,224,244,0.55)';
        }
      }
      if (bridgeEyebrow) {
        var eyebrowEmpty = emptyOf(bridgeEyebrow);
        // A swatch pick has no name behind it, so it cannot use the
        // "{name}'S SHADE" line — that is only for a tapped face.
        if (!pick) bridgeEyebrow.textContent = eyebrowEmpty;
        else if (state.pickFace) bridgeEyebrow.textContent = fill(strings.bridgeEyebrowPick, { name: state.pickFace.toUpperCase() });
        else bridgeEyebrow.textContent = strings.bridgeEyebrowOwn || eyebrowEmpty;
      }
      if (bridgeLine) {
        var lineEmpty = emptyOf(bridgeLine);
        bridgeLine.textContent = pick ? fill(strings.bridgeLinePick, { shade: pick }) : lineEmpty;
      }

      // Matcher panel + sticky bar follow the PICK.
      each('[data-ssd10-result-swatch]', function (el) { setSwatchBox(el, pick); });
      each('[data-ssd10-result-code]', function (el) {
        var empty = emptyOf(el);
        el.textContent = pick ? fill(strings.codeMatched, { shade: pick }) : empty;
      });
      each('[data-ssd10-result-note]', function (el) {
        var empty = emptyOf(el);
        if (state.pickFace) el.textContent = fill(strings.noteFace, { name: state.pickFace });
        else if (pick && shades[pick]) el.textContent = shades[pick].tier + ' skintone, ' + TONE_WORD[shades[pick].tone];
        else el.textContent = empty;
      });
      each('[data-ssd10-bar-note]', function (el) {
        var empty = emptyOf(el);
        el.textContent = pick ? (strings.stickyNoteMatched || empty) : empty;
      });

      // The panel shows the picked shade worn: the face block's own override
      // if it has one, else that shade's before/after from the concealer
      // product, which covers all 19. Only with nothing picked is it the still.
      renderCarousel(pick);
      renderFollows(pick);

      // Faces: pressed state marks the pick.
      each('[data-ssd10-face]', function (el) {
        el.setAttribute('aria-pressed', el.dataset.shade === pick ? 'true' : 'false');
      });

      // Swatch grid: tone filter, pick ring, and the matched flag, which is
      // independent of the ring — picking elsewhere must not move the flag.
      each('[data-ssd10-swatch]', function (el) {
        var code = el.dataset.shade;
        el.hidden = !(state.tone === 'all' || el.dataset.tone === state.tone);
        el.setAttribute('aria-pressed', code === pick ? 'true' : 'false');
        el.classList.toggle('is-matched', code === matched);
        if (!el.dataset.label) el.dataset.label = el.getAttribute('aria-label') || code;
        el.setAttribute('aria-label', code === matched
          ? el.dataset.label.replace(/^([^,]+)/, '$1, matched')
          : el.dataset.label);
        var flag = el.querySelector('[data-ssd10-swatch-flag]');
        if (flag) flag.hidden = code !== matched;
      });

      each('[data-ssd10-chip]', function (el) {
        var on = el.dataset.ssd10Chip === state.tone;
        el.classList.toggle('is-active', on);
        el.setAttribute('aria-pressed', on ? 'true' : 'false');
      });

      var key = document.querySelector('.ssd10__matched-key');
      if (key) key.hidden = !matched;
      // Post-match every CTA buys, so these links are the way back into Violet.
      each('[data-ssd10-rematch]', function (el) { el.hidden = !matched; });

      announce(matched, pick);

      // The two buy buttons.
      var variant = variantFor(pick);
      var soldOut = !!(pick && (!variant || !variant.a));
      each('[data-ssd10-primary-cta]', function (btn) {
        var label = btn.querySelector('[data-ssd10-primary-label]');
        if (label) {
          // The matcher and the sticky bar each render their own pre-pick
          // label, so the empty state comes from the DOM, not a shared string.
          var labelEmpty = emptyOf(label);
          if (!pick) label.textContent = labelEmpty;
          else if (soldOut) label.textContent = strings.soldOut;
          else label.textContent = fill(strings.ctaMatched, { shade: pick, price: strings.price || '' });
        }
        var short = btn.querySelector('[data-ssd10-primary-label-short]');
        if (short) {
          var shortEmpty = emptyOf(short);
          if (!pick) short.textContent = shortEmpty;
          else if (soldOut) short.textContent = strings.soldOut;
          else short.textContent = fill(strings.bagLabelShort || 'Add to bag · {shade}', { shade: pick, price: strings.price || '' });
        }
        btn.setAttribute('aria-disabled', soldOut ? 'true' : 'false');
        btn.dataset.variantId = variant && variant.a ? String(variant.id) : '';
      });
    }

    // Nothing moves focus when a shade is picked or a match arrives, so the
    // change is spoken instead. Only announce when the message actually
    // changes, or every re-render repeats itself.
    var lastSaid = '';
    function announce(matched, pick) {
      var live = document.querySelector('[data-ssd10-live]');
      if (!live) return;
      var said = '';
      if (matched && matched === pick) {
        said = fill(strings.mineLine, { shade: matched }) + ' ' + priceLabel(matched) + '.';
      } else if (pick && !document.querySelector('[data-ssd10-follows]')) {
        var sh = shades[pick];
        said = fill(strings.codeMatched, { shade: pick })
          + (sh ? '. ' + sh.tier + ' skintone, ' + TONE_WORD[sh.tone] : '')
          + (state.pickFace ? '. ' + fill(strings.noteFace, { name: state.pickFace }) : '') + '.';
      }
      if (said === lastSaid) return;
      lastSaid = said;
      live.textContent = said;
    }

    function say(message) {
      var live = document.querySelector('[data-ssd10-live]');
      if (!live) return;
      lastSaid = message;
      live.textContent = message;
    }

    // ── Carousel ────────────────────────────────────────────────────────────
    // The Stak's own gallery for the picked shade, exactly as the Stak PDP
    // shows it for that variant (sections/main-product-premade.liquid): an
    // image is in when its alt is blank or the product title, when one of
    // its comma-separated alt values is a selected option ("Fair 1C,Fair 2N,
    // Fair 3N"), or when the alt contains one ("004N on skin"). The variant
    // is the picked concealer plus the BB Powder it resolves to. First five
    // in product order; the second (the before/after) shows by default.
    // Nothing here knows what the pictures depict, and a shade with fewer
    // than five simply gets fewer. The set is the PDP's, exactly — a
    // reviewer card's own before/after is not spliced in.
    var carousel = { code: null, index: 0, urls: [] };

    function slidesFor(code) {
      var out = [];
      var seen = {};
      function add(u) { if (u && !seen[u]) { seen[u] = 1; out.push(u); } }
      if (!code) return out;
      var p = pairingFor(code);
      var values = [p.bb, code].filter(Boolean).map(String);
      var title = String(ssdMedia.title || '');
      (ssdMedia.media || []).forEach(function (m) {
        if (out.length >= 5) return;
        var alt = String(m.a || '').trim();
        var show = !alt || alt === title;
        if (!show) {
          var parts = alt.split(',').map(function (x) { return x.trim(); });
          show = parts.some(function (x) { return values.indexOf(x) !== -1; })
            || values.some(function (v) { return alt.indexOf(v) !== -1; });
        }
        if (show) add(m.s);
      });
      if (!out.length && worn[code]) add(worn[code]);
      return out.slice(0, 5);
    }

    // Slide 3 is the concealer's own on-skin shot in the PDP's image order,
    // so it is the one to open on; fall back to whatever exists.
    function defaultSlide(urls) { return Math.min(2, Math.max(0, urls.length - 1)); }

    function renderCarousel(code) {
      var root = document.querySelector('[data-ssd10-carousel]');
      if (!root) return;
      var track = root.querySelector('[data-ssd10-slides]');
      var nav = root.querySelector('[data-ssd10-carousel-nav]');
      var jaw = root.querySelector('[data-ssd10-jaw]');
      if (code !== carousel.code) {
        carousel.code = code;
        carousel.urls = code ? slidesFor(code) : [];
        carousel.index = defaultSlide(carousel.urls); // never keeps the old position
        if (!carousel.urls.length) carousel.urls = [jaw ? jaw.dataset.default : ''].filter(Boolean);
        var alt = jaw ? jaw.getAttribute('alt') : '';
        track.innerHTML = '';
        carousel.urls.forEach(function (u, i) {
          var img = document.createElement('img');
          img.className = 'ssd10__slide';
          img.src = u;
          img.alt = alt;
          img.width = 1100; img.height = 1100;
          img.loading = i === carousel.index ? 'eager' : 'lazy';  // only the shown one is needed on paint
          if (i === 0) { img.setAttribute('data-ssd10-jaw', ''); img.dataset.default = jaw ? jaw.dataset.default : ''; }
          track.appendChild(img);
        });
      }
      var slides = track.querySelectorAll('.ssd10__slide');
      Array.prototype.forEach.call(slides, function (el, i) {
        el.classList.toggle('is-active', i === carousel.index);
        el.setAttribute('aria-hidden', i === carousel.index ? 'false' : 'true');
      });
      if (nav) {
        nav.hidden = slides.length <= 1;
        var count = nav.querySelector('[data-ssd10-slide-count]');
        if (count) count.textContent = fill(strings.slideOf || '{n} / {total}', { n: carousel.index + 1, total: slides.length });
        var prev = nav.querySelector('[data-ssd10-slide-prev]'), next = nav.querySelector('[data-ssd10-slide-next]');
        if (prev) prev.disabled = carousel.index === 0;
        if (next) next.disabled = carousel.index >= slides.length - 1;
      }
      measureCarousel();
    }

    // The slides are object-fit: contain inside a box that the matcher grid
    // stretches, so the photo does not fill it. Measure where the active
    // photo actually lands and hand it to the stylesheet, so the arrows sit
    // at the photo's mid-height and the count sits in its corner instead of
    // floating in the cream above it.
    function measureCarousel() {
      var root = document.querySelector('[data-ssd10-carousel]');
      var img = root && root.querySelector('.ssd10__slide.is-active');
      if (!img) return;
      var apply = function () {
        var bw = root.clientWidth, bh = root.clientHeight, nw = img.naturalWidth, nh = img.naturalHeight;
        if (!bw || !bh || !nw || !nh) return;
        var scale = Math.min(bw / nw, bh / nh);
        var h = nh * scale;
        var pos = (getComputedStyle(img).objectPosition || '50% 50%').split(' ');
        var y = parseFloat(pos[1] || '50') / 100;   // the stylesheet's object-position
        root.style.setProperty('--ssd10-img-top', Math.round((bh - h) * y) + 'px');
        root.style.setProperty('--ssd10-img-h', Math.round(h) + 'px');
      };
      if (img.complete && img.naturalWidth) apply(); else img.addEventListener('load', apply, { once: true });
    }
    window.addEventListener('resize', measureCarousel);

    function stepCarousel(delta) {
      var total = carousel.urls.length;
      if (total <= 1) return;
      carousel.index = Math.max(0, Math.min(total - 1, carousel.index + delta));
      renderCarousel(carousel.code);
    }

    // Swipe. Delegated on the document so it binds whenever the section
    // renders. A horizontal drag past 40px steps one slide; the
    // track keeps touch-action: pan-y so vertical scrolling stays native.
    var swipe = { x: null, y: null };
    document.addEventListener('pointerdown', function (e) {
      var car = e.target.closest && e.target.closest('[data-ssd10-carousel]');
      if (!car || e.target.closest('button')) { swipe.x = null; return; }
      swipe.x = e.clientX; swipe.y = e.clientY;
    }, { passive: true });
    document.addEventListener('pointerup', function (e) {
      if (swipe.x == null) return;
      var dx = e.clientX - swipe.x, dy = e.clientY - swipe.y;
      swipe.x = null;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) stepCarousel(dx < 0 ? 1 : -1);
    }, { passive: true });
    document.addEventListener('pointercancel', function () { swipe.x = null; });

    // ── "The rest of the Stak follows" ───────────────────────────────────────
    // Follows the pick; with nothing picked it shows the first shade visible
    // in the current tone tab as the worked example, so it repaints on tab
    // changes too. One atomic live region, so it is spoken once per selection.
    function renderFollows(pick) {
      var el = document.querySelector('[data-ssd10-follows]');
      if (!el || !strings.followsLine) return;
      var code = pick;
      if (!code) {
        var first = document.querySelector('[data-ssd10-swatch]:not([hidden])');
        code = first ? first.dataset.shade : '004N';
      }
      var p = pairingFor(code);
      // The merchant-facing setting says {code} for the concealer; the
      // pairing calls it concealer. Accept both.
      var vars = { code: p.concealer, concealer: p.concealer, bb: p.bb, bronzer: p.bronzer, lipcheek: p.lipcheek, eyeshadow: p.eyeshadow };
      var esc = function (v) { return String(v || '').replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
      var html = esc(strings.followsLine)
        .replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>')
        .replace(/\{(\w+)\}/g, function (whole, k) { return esc(vars[k] != null ? vars[k] : whole); });
      if (el.innerHTML !== html) el.innerHTML = html;
    }

    // Multiplies readably over the pan photo: the pressed texture stays visible.
    function lighten(hex, k) {
      function part(i) {
        return Math.min(255, Math.round(parseInt(hex.slice(i, i + 2), 16) * k));
      }
      return 'rgb(' + part(1) + ',' + part(3) + ',' + part(5) + ')';
    }

    // ── Interactions ────────────────────────────────────────────────────────

    function setPick(code, faceName) {
      hideNudge();
      state.pick = code || null;
      state.pickFace = faceName || null;
      render();
    }

    document.addEventListener('click', function (e) {
      var face = e.target.closest('[data-ssd10-face]');
      if (face ) {
        setPick(face.dataset.shade, face.dataset.name || '');
        var matcher = document.querySelector('#ssd10-shade');
        if (matcher) matcher.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }

      var swatch = e.target.closest('[data-ssd10-swatch]');
      if (swatch) {
        setPick(swatch.dataset.shade, null);
        return;
      }

      var slidePrev = e.target.closest('[data-ssd10-slide-prev]');
      if (slidePrev) { stepCarousel(-1); return; }
      var slideNext = e.target.closest('[data-ssd10-slide-next]');
      if (slideNext) { stepCarousel(1); return; }

      var chip = e.target.closest('[data-ssd10-chip]');
      if (chip) {
        state.tone = chip.dataset.ssd10Chip;
        render();
        return;
      }

      var human = e.target.closest('[data-open-kustomer]');
      if (human) { e.preventDefault(); openKustomer(); return; }

      var buy = e.target.closest('[data-ssd10-primary-cta]');
      if (buy) {
        e.preventDefault();
        if (buy.getAttribute('aria-disabled') === 'true') return;
        if (!buy.dataset.variantId) {
          // Nothing picked yet: the sticky bar's job is to start a match, the
          // matcher's is to get the shopper to the grid it sits under.
          // Nothing in play: every buy button is a way into Violet.
          openChat();
          return;
        }
        addToBag(buy);
        return;
      }

      // Post-match every CTA buys. Pre-match they still carry
      // [data-open-chat] and layout/landing.liquid handles them.
      var cta = e.target.closest('[data-ssd10-cta]');
      if (cta && state.matched) {
        e.preventDefault();
        addToBag(cta);
      }
    });

    // The pick-first nudge is gone: with nothing in play the CTA opens Violet.
    function hideNudge() {
      var el = document.querySelector('[data-ssd10-nudge]');
      if (el && !el.hidden) { el.hidden = true; el.textContent = ''; }
    }

    // ── Reviews: Okendo's widget, collapsed until asked for ─────────────────
    // "Read all N reviews" and every star label open it; the widget is
    // Okendo's own and is only shown or hidden here.
    var okr = document.querySelector('[data-ssd10-reviews]');
    function setReviewsOpen(open) {
      if (!okr) return;
      var body = okr.querySelector('[data-ssd10-reviews-body]');
      var toggle = okr.querySelector('[data-ssd10-reviews-toggle]');
      if (body) body.hidden = !open;
      if (toggle) {
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        toggle.textContent = open ? toggle.dataset.hide : toggle.dataset.read;
      }
      // Okendo measured its carousel while hidden; let it re-measure.
      if (open) window.setTimeout(function () { window.dispatchEvent(new Event('resize')); }, 50);
    }
    document.addEventListener('click', function (e) {
      var toggle = e.target.closest && e.target.closest('[data-ssd10-reviews-toggle]');
      if (toggle && okr) { setReviewsOpen(toggle.getAttribute('aria-expanded') !== 'true'); return; }
      var jump = e.target.closest && e.target.closest('a[href="#ssd10-reviews"]');
      if (jump && okr) {
        e.preventDefault();
        setReviewsOpen(true);
        okr.scrollIntoView({ behavior: 'smooth', block: 'start' });
        var t = okr.querySelector('[data-ssd10-reviews-toggle]');
        if (t) t.focus({ preventScroll: true });
      }
    });
    if (okr && window.location.hash === '#ssd10-reviews') setReviewsOpen(true);

    // Arrow keys move the carousel when it (or a control in it) has focus.
    document.addEventListener('keydown', function (e) {
      if (!e.target.closest || !e.target.closest('[data-ssd10-carousel]')) return;
      if (e.key === 'ArrowLeft') { e.preventDefault(); stepCarousel(-1); }
      else if (e.key === 'ArrowRight') { e.preventDefault(); stepCarousel(1); }
    });

    // Shade-match entry: Violet (the in-house matcher) when the flyout is on
    // the page, Kustomer chat otherwise. openKustomer stays as the human
    // handoff Violet itself uses.
    function openChat() {
      if (window.SubtlViolet && typeof window.SubtlViolet.open === 'function') { window.SubtlViolet.open(); return; }
      openKustomer();
    }
    function openKustomer() {
      if (window.Kustomer && typeof window.Kustomer.open === 'function') {
        window.Kustomer.open();
        if (typeof window.Kustomer.createConversation === 'function') {
          window.Kustomer.createConversation({}, function () {});
        }
      }
    }

    function addToBag(trigger) {
      var code = state.pick || state.matched;
      var variant = variantFor(code);
      if (!variant || !variant.a) return;

      trigger.classList.add('is-loading');
      var routeRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

      var item = { id: variant.id, quantity: 1 };
      // Underscore-prefixed properties do not render in the cart or at
      // checkout, but do reach the order — which is what "carry it into the
      // cart line item" needs.
      item.properties = { _shade_match: code };
      if (state.matched) item.properties._shade_matched_by = state.matchedBy || 'chat';
      if (state.matchId) item.properties._violet_match_id = state.matchId;
      var pairing = pairingFor(code);
      if (pairing.bb) item.properties._bb_powder = pairing.bb;
      if (pairing.bronzer) item.properties._powder_bronzer = pairing.bronzer;
      if (pairing.lipcheek) item.properties._lip_and_cheek = pairing.lipcheek;
      if (pairing.eyeshadow) item.properties._eyeshadow_duo = pairing.eyeshadow;

      fetch(routeRoot + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [item] })
      })
        .then(function (r) { return r.json().catch(function () { return null; }); })
        .then(function () {
          trigger.classList.remove('is-loading');
          bumpCartCount();
          // Rebuy Smart Cart auto-opens off an AJAX post to /cart/add.js.
          // Nudge it only if it is already past initialising — calling show()
          // during 'initializing' just sets pendingShow and can wedge it.
          var sc = window.Rebuy && window.Rebuy.SmartCart;
          if (sc && sc.status === 'ready' && typeof sc.show === 'function') sc.show();
          say(fill(strings.addedLine || 'Added to your bag in {shade}.', { shade: code }));
          document.dispatchEvent(new CustomEvent('subtl:ssd10:added', { detail: { code: code } }));
        })
        .catch(function () {
          trigger.classList.remove('is-loading');
          say(strings.addFailedLine || 'Sorry, that could not be added to your bag. Please try again.');
        });
    }

    function bumpCartCount() {
      var routeRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(routeRoot + 'cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          each('[data-ssd10-cart-count]', function (el) {
            el.textContent = cart.item_count;
            el.hidden = cart.item_count === 0;
          });
        })
        .catch(function () { /* the count is decoration; the add already succeeded */ });
    }

    // A match used to scroll the shopper to the matcher, which yanked them
    // out of whatever they were reading. Instead the buy CTAs pulse once as
    // each comes into view, so the change announces itself where they already
    // are and again as they scroll. Fires once per CTA, and the page-wide
    // reduced-motion rule turns it off for anyone who asked.
    function glowCtas() {
      if (!state.matched || typeof IntersectionObserver !== 'function') return;
      // A shopper waiting on a person in chat is often on another tab when the
      // answer lands. Arming now would let the observer fire and burn the
      // animation while nobody is watching, so they would come back to a page
      // that had already finished glowing. Wait until they are actually here.
      if (document.hidden) {
        document.addEventListener('visibilitychange', function once() {
          if (document.hidden) return;
          document.removeEventListener('visibilitychange', once);
          glowCtas();
        });
        return;
      }
      var els = document.querySelectorAll('[data-ssd10-cta], [data-ssd10-primary-cta]');
      if (!els.length) return;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var el = entry.target;
          io.unobserve(el);
          el.classList.add('is-glowing');
          setTimeout(function () { el.classList.remove('is-glowing'); }, 4200);
        });
      }, { threshold: 0.55 });
      Array.prototype.forEach.call(els, function (el) { io.observe(el); });
    }

    // ── Deep link: ?shade=004N (email campaigns, "your shade is waiting") ────
    // Applied as a match once, only when nothing is matched yet, through the
    // same writer as every other match.
    (function () {
      try {
        var code = (new URLSearchParams(window.location.search).get('shade') || '').trim().toUpperCase();
        if (!code || !shades[code] || state.matched) return;
        var sink = document.querySelector('[data-ssd10-sink="concealer"]');
        if (!sink) return;
        state.matchedBy = 'link';
        window.setTimeout(function () { sink.value = code; sink.dispatchEvent(new Event('change', { bubbles: true })); }, 0);
      } catch (e) { /* ignore */ }
    })();

    // ── Sticky bar: fixed to the viewport, the page pads for it ──────────────
    (function () {
      var bar = document.querySelector('[data-ssd10-sticky]');
      if (!bar) return;
      var set = function () { document.documentElement.style.setProperty('--ssd10-sticky-h', bar.offsetHeight + 'px'); };
      set();
      if ('ResizeObserver' in window) new ResizeObserver(set).observe(bar); else window.addEventListener('resize', set);
    })();

    // ── Bridge for the Violet flyout (assets/ssd-violet.js) ─────────────────
    // The flyout never touches page state directly. applyMatch() writes the
    // match through the same hidden select a Kustomer match uses, so every
    // rule about matched vs picked keeps holding.
    window.SubtlSSD10A = {
      shades: shades,
      handles: readJSON('[data-ssd10-handles]', {}),
      price: strings.price || '',
      pairingFor: pairingFor,
      variantFor: variantFor,
      panFor: function (role, shade) {
        return ((pans.variant || {})[role] || {})[shade] || ((pans.pan || {})[role] || {})[shade] || '';
      },
      applyMatch: function (code, meta) {
        var sink = document.querySelector('[data-ssd10-sink="concealer"]');
        if (!sink || !shades[code]) return false;
        state.matchedBy = (meta && meta.by) || 'violet';
        state.matchId = (meta && meta.matchId) || null;
        sink.value = code;
        sink.dispatchEvent(new Event('change', { bubbles: true }));
        return true;
      },
      suggest: function (code) { if (shades[code]) setPick(code, null); },
      addToBag: function () {
        var btn = document.querySelector('.ssd10__matcher-cta[data-ssd10-primary-cta]') || document.querySelector('[data-ssd10-primary-cta]');
        if (btn) addToBag(btn);
      },
      // The flyout adds companions (tools, refills) on its own; the page's
      // cart count still has to follow.
      refreshCart: bumpCartCount,
      openKustomer: openKustomer
    };

    // ── The only writer of `matched` ────────────────────────────────────────
    // violet-shade-match.js sets these selects and dispatches `change`.

    var concealerSink = document.querySelector('[data-ssd10-sink="concealer"]');
    var bbSink = document.querySelector('[data-ssd10-sink="bb"]');

    if (concealerSink) {
      concealerSink.addEventListener('change', function () {
        var code = (concealerSink.value || '').trim().toUpperCase();
        if (!shades[code]) return;
        state.matched = code;
        if (toneOf(code)) state.tone = toneOf(code);
        state.pick = code;
        state.pickFace = null;
        hideNudge();
        persist();
        render();
        glowCtas();
      });
    }

    if (bbSink) {
      bbSink.addEventListener('change', function () {
        state.matchedBB = (bbSink.value || '').trim() || null;
        persist();
        render();
      });
    }

    render();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  // Violet's matched hearts beat twice each time they scroll into view
  // (the CSS keys the beat off is-inview).
  (function () {
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { e.target.classList.toggle('is-inview', e.isIntersecting); });
    }, { threshold: 0.6 });
    document.querySelectorAll('.ssd10__swatch-flag, .ssd10__badge-heart, .ssd10__matcher-swatch-badge, .ssd10__matched-key').forEach(function (el) { io.observe(el); });
  })();

  // Theme editor: a section re-render replaces DOM the binding layer was
  // holding, so re-run against the new markup.
  document.addEventListener('shopify:section:load', function () {
    document.documentElement.__ssd10Bound = false;
    boot();
  });
})();
